import React, { Component } from 'react'
import Header from '../Header'
import './XIw.css'

class XIw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXIw">
                    <p className="textXIw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default XIw